import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Bracket, BracketResponse } from './types';


const BRACKETS_TAG = 'Brackets';

export const bracketsApi = createApi({
  reducerPath: 'bracketsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/brackets_v1/' }),
  tagTypes: [BRACKETS_TAG],
  endpoints: (builder) => ({
    getBracketById: builder.query<Bracket, string>({
      query: (tournamentId) => `${tournamentId}/`,
      transformResponse: (response: BracketResponse) => response.data,
      providesTags: (result, error, tournamentId) => [{ type: BRACKETS_TAG, id: tournamentId }],
    }),
  }),
});

export const {
  useGetBracketByIdQuery,
} = bracketsApi;
